import type { NotificationChannelInfo, NotificationChannelEvent } from '../notification-channel/models'

export const DEFAULT_CHANNEL_LIFETIME = 3600
export const PING_INTERVAL_MS = 8000
export const PONG_TIMEOUT_INTERVAL_MS = 4000
export const CHANNEL_REFRESH_PERCENTAGE = 0.75

export interface NotificationChannel {
  readonly id: string
  readonly channelInfo?: NotificationChannelInfo
  start(): void
  /**
   * @deprecated
   * Use eventBus with `NotificationChannel` namespace instead
   * @param eventListener
   */
  subscribe<T>(eventListener: (event: NotificationChannelEvent<T>) => void): void
  /**
   * @deprecated
   * Use eventBus with `NotificationChannel` namespace instead
   * @param eventListener
   */
  unsubscribe<T>(eventListener: (event: NotificationChannelEvent<T>) => void): void
}
